/*eslint-disable*/
const html_start = `
					<html
						xmlns:v="urn:schemas-microsoft-com:vml"
						xmlns:o="urn:schemas-microsoft-com:office:office"
						xmlns:x="urn:schemas-microsoft-com:office:excel"
						xmlns="http://www.w3.org/TR/REC-html40"
					>`;
const templateExcelWorksheet = `
					<x:ExcelWorksheet>
						<x:Name>{SheetName}</x:Name>
						<x:WorksheetOptions>
							<x:DisplayGridlines/>
						</x:WorksheetOptions>
						<x:WorksheetSource HRef="sheet{SheetIndex}.htm"/>
					</x:ExcelWorksheet>`;
const templateListWorksheet = `<o:File HRef="sheet{SheetIndex}.htm"/>`;
const templateHTMLWorksheet =
	`
------=_NextPart_dummy
Content-Location: sheet{SheetIndex}.htm
Content-Type: text/html; charset=windows-1252

` +
	html_start +
	`
<head>
  <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">
  <link id="Main-File" rel="Main-File" href="../WorkBook.htm">
  <link rel="File-List" href="filelist.xml">
  <!--[if gte mso 9]>
	<xml>
		<x:ExcelWorkbook>
			<x:ExcelWorksheets>
				<x:ExcelWorksheet>
					<x:WorksheetOptions>
						<x:DisplayGridlines/>
					</x:WorksheetOptions>
				</x:ExcelWorksheet>
			</x:ExcelWorksheets>
		</x:ExcelWorkbook>
	</xml>
<![endif]-->
<style>
br {mso-data-placement:same-cell;}
</style>
</head>
<body>{SheetContent}</body>
</html>`;
const templateWorkBook =
	`MIME-Version: 1.0
X-Document-Type: Workbook
Content-Type: multipart/related; boundary="----=_NextPart_dummy"

------=_NextPart_dummy
Content-Location: WorkBook.htm
Content-Type: text/html; charset=windows-1252

` +
	html_start +
	`
<head>
<meta name="Excel Workbook Frameset">
<meta http-equiv="Content-Type" content="text/html; charset=windows-1252">
<link rel="File-List" href="filelist.xml">
<!--[if gte mso 9]><xml>
 <x:ExcelWorkbook>
  <x:ExcelWorksheets>{ExcelWorksheets}<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheets>
  <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
  <x:ActiveSheet>0</x:ActiveSheet>
 </x:ExcelWorkbook>
</xml><![endif]-->
</head>
<frameset>
  <frame src="sheet0.htm" name="frSheet">
  <noframes><body><p>This page uses frames, but your browser does not support them.</p></body></noframes>
</frameset>
</html>
{HTMLWorksheets}
Content-Location: filelist.xml
Content-Type: text/xml; charset="utf-8"

<xml xmlns:o="urn:schemas-microsoft-com:office:office">
  <o:MainFile HRef="../WorkBook.htm"/>
  {ListWorksheets}
  <o:File HRef="filelist.xml"/>
</xml>
------=_NextPart_dummy--
`;

export default {
	templateExcelWorksheet,
	templateHTMLWorksheet,
	templateListWorksheet,
	templateWorkBook
};
